import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  copy(e) {
   
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.element.dataset.text).then(
        () => {
            e.target.classList.add('copied')
            setTimeout(() => {
              e.target.classList.remove('copied');
            }, 2000);
        },
      );
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement("textarea");
      textArea.value = this.element.dataset.text;
      // Move textarea out of the viewport so it's not visible
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";
      document.body.prepend(textArea);
      textArea.select();
      try {
          document.execCommand('copy');
      } catch (error) {
          console.error(error);
      } finally {
          e.target.classList.add('copied')
          setTimeout(() => {
            e.target.classList.remove('copied');
          }, 2000);
          textArea.remove();
      }
    }
  }
}
